export default {
  attach_all_file: 'All Files',
  attach_root_folder: 'Root Directory',
  attach_table_name: 'Name',
  attach_table_size: 'Size',
  attach_table_permissions_read: 'Read Permission',
  attach_table_permissions_write: 'Write Permission',
  attach_table_create_user: 'Creator',
  attach_table_create_time: 'Creation Time',
  attach_table_dir_rename: 'Rename Directory',

  attach_confirm_delete_attach_title: 'Are you sure you want to delete this attachment?',
  attach_confirm_delete_attach_content: 'Attachment Name: {name}',
  attach_confirm_delete_dir_title: 'Are you sure you want to delete this directory?',
  attach_confirm_delete_dir_content: 'Directory Name: {name}',

  attach_menu: 'Attachment',
  attach_menu_add: 'Add Attachment',

  attach_form_name: 'Attachment Name',
  attach_form_name_placeholder: 'Please enter the attachment name',
  attach_form_status: 'Attachment Status',
  attach_form_status_placeholder: 'Please select a status',
  attach_form_description: 'Attachment Description',
  attach_form_description_placeholder: 'Please enter the attachment description',
  attach_form_icon: 'Attachment Icon',
  attach_form_bind_username: 'Bind User',
  attach_form_bind_username_placeholder: 'Please select a user to bind',
  attach_form_app_id_placeholder: 'Please enter appId',
  attach_form_app_secret_placeholder: 'Please enter appSecret',
  attach_form_auto_generation_placeholder: 'Automatically generated by the system',
  attach_form_folder_search_placeholder: 'Search folder',
  attach_form_file_search_placeholder: 'Search file',

  // Context menu
  attach_menu_new_folder: 'New Folder',
  attach_menu_upload: 'Upload Attachment',
  attach_menu_share: 'Share',
  attach_menu_edit: 'Edit',
  attach_menu_download: 'Download Attachment',
  attach_menu_delete: 'Delete',
  attach_menu_rename: 'Rename',

  // Form labels
  attach_form_type: 'Attachment Type',
  attach_form_type_placeholder: 'Please select a attachment type',
  attach_form_dir_type: 'Folder Type',
  attach_form_dir_type_placeholder: 'Please select a folder type',
  attach_form_folder: 'Folder',
  attach_form_new_folder: 'New Folder',
  attach_form_file_name: 'File Name',
  attach_form_file_name_placeholder: 'Please enter the file name',
  attach_form_file_size: 'File Size',
  attach_form_folder_placeholder: 'Please select a folder',
  attach_form_edit_folder: 'Edit Folder',
  attach_form_folder_name: 'Folder Name',
  attach_form_read_permission: 'Read Permission',
  attach_form_write_permission: 'Write Permission',
  attach_form_download_permission: 'Download Permission',
  attach_form_file_desc: 'File Descriptioin',
  attach_form_file_desc_placeholder: 'Please enter file description',
  attach_form_folder_desc: 'Folder Description',
  attach_form_attach_upload: 'Upload Attachment',
  attach_form_attach_edit: 'Edit Attachment',
  attach_form_path: 'Path',
  attach_form_folder_read_permission: 'Folder Read Permission',
  attach_form_folder_write_permission: 'Folder Write Permission',

  // Form placeholders
  attach_form_folder_name_placeholder: 'Please enter the folder name',
  attach_form_upload_target_folder: 'Select upload folder',
  attach_form_read_permission_placeholder: 'Select read permission level',
  attach_form_write_permission_placeholder: 'Select write permission level',
  attach_form_download_permission_placeholder: 'Select download permission level',
  attach_form_folder_desc_placeholder: 'Please enter a brief description',
  attach_form_min_level_limit_tips: 'Cannot be lower than folder permission level {level}',

  // Other possible required fields
  attach_title: 'Document Attachment',
  attach_upload_success: 'Upload successful',
  attach_upload_failed: 'Upload failed',
  attach_delete_success: 'Delete successful',
  attach_rename_success: 'Rename successful',
  attach_create_folder_success: 'Create folder successful',
  attach_edit_folder_success: 'Edit folder successful',

  // Confirmation prompts
  attach_confirm_delete: 'Are you sure you want to delete this {type}?',
  attach_confirm_delete_folder:
    'Deleting the folder will also delete all files under it, do you want to continue?',

  // Permission levels
  attach_permission_public: 'Public',
  attach_permission_private: 'Private',
  attach_permission_custom: 'Custom',

  attach_share_title: 'Attachment Sharing',
  attach_share_file_count: '{count} files',
  attach_share_validity: 'Validity Period',
  attach_share_validity_1_day: '1 day',
  attach_share_validity_7_days: '7 days',
  attach_share_validity_30_days: '30 days',
  attach_share_validity_days: '{days} days',
  attach_share_validity_forever: 'Permanent',
  attach_share_access_code: 'Access Code',
  attach_share_validity_date: 'valid until {date}',
  attach_share_need_code: 'Required',
  attach_share_no_code: 'Not required',
  attach_share_access_code_input: 'Set access code',
  attach_share_access_code_placeholder: 'Please enter access code',
  attach_share_continue: 'Continue sharing',
  attach_share_success_title: 'Share successful',
  attach_share_success_msg: 'Successfully created share link',
  attach_share_link_placeholder: 'Share link',
  attach_share_copy_link: 'Copy link',
  attach_share_copy_success: 'Copy successful',
  attach_share_copy_failed: 'Copy failed',
  attach_share_validity_required: 'Please select a validity period',
  attach_share_access_code_rule: 'Please enter a 4-digit access code',
  attach_share_link: 'Share Link',
  attach_share_name: 'Name',
  attach_share_size: 'Size',
  attach_share_expired: 'File sharing has expired',

  attach_download_confirm: 'Are you sure you want to download the file?',

  attach_form_attach_type: 'Attachment Type',
  attach_form_attach_type_normal: 'Normal',
  attach_form_attach_type_firmware: 'Firmware',
  attach_form_attach_type_log: 'Log',
  attach_form_attach_type_issue: 'Issue',

  attach_share_destroy_confirm: 'Are you sure to destroy this share?',
  attach_share_destroy_success: ' Destroy Successful',
};
